// Module 10.6 — line-heat crisis buckets (§7). Crisis buckets line loadingPct and pulses only when
// overloaded (≥100%). Phase 0.4: encodeFaults + outageNodeIds REMOVED — they produced spec.faults and
// spec.outageNodes, both of which were dead (the adapter derives outage info from branchFlows.energized
// + AssetSpec.lit, and never reads spec.faults). Only encodeCrisis survives — it drives the live crisis
// band that the adapter reads at spec.crisis.
import type { BranchFlow } from "../../domain/index";
import type { CrisisSpec, CrisisBucket } from "./spec";

function bucketOf(loadingPct: number): CrisisBucket {
  if (loadingPct >= 100) return "red";
  if (loadingPct >= 85) return "hot";
  if (loadingPct >= 70) return "warn";
  if (loadingPct >= 40) return "load"; // ≥40% — a working line warms up so capacity is visible on the secure grid
  return "base";
}

export function encodeCrisis(branchFlows: readonly BranchFlow[]): CrisisSpec[] {
  return branchFlows.map((bf) => {
    const bucket = bucketOf(bf.loadingPct);
    return { edgeId: bf.edgeId as string, bucket, pulse: bucket === "red", loadingPct: bf.loadingPct };
  });
}
